import { computed, ComputedRef, watch } from 'vue';
import { useChartStyleJsonCache } from '@/composables/useChartStyleJsonCache';
import { useWorkbenchSelections } from '@/composables/useWorkbenchSelections';
import { areChartStyleObjectsEqual } from '@/composables/areChartStyleObjectsEqual';

let doesChartBeingViewedHaveUnsavedChanges: ComputedRef<boolean> | undefined;
let doesChartStyleBeingViewedHaveUnsavedChanges: ComputedRef<boolean> | undefined;

let hasInitialized = false;

function setPageOnBeforeUnloadCallback() {
  const { chartBeingViewed } = useWorkbenchSelections();

  if (
    !chartBeingViewed.value ||
    !doesChartBeingViewedHaveUnsavedChanges?.value
  ) {
    window.onbeforeunload = null;
    return;
  }

  window.onbeforeunload = () => { return true; };
}

export function useUnsavedChangesDetection() {
  const {
    chartStyleJsonBeingViewed,
    chartStyleJsonOfChartBeingViewed,
    chartStyleJsonOfChartStyleBeingViewed
  } = useChartStyleJsonCache();
  const { chartBeingViewed } = useWorkbenchSelections();

  doesChartBeingViewedHaveUnsavedChanges = doesChartBeingViewedHaveUnsavedChanges ?? computed(() => {
    // TODO: do we need to do a comparison of chart.symbol to chartStore.symbol here?

    if (!chartStyleJsonOfChartBeingViewed.value || !chartStyleJsonBeingViewed.value) {
      return true;
    }

    return !areChartStyleObjectsEqual(chartStyleJsonOfChartBeingViewed.value, chartStyleJsonBeingViewed.value);
  });

  doesChartStyleBeingViewedHaveUnsavedChanges = doesChartStyleBeingViewedHaveUnsavedChanges ?? computed(() => {
    if (!chartStyleJsonOfChartStyleBeingViewed.value || !chartStyleJsonBeingViewed.value) {
      return true;
    }

    return !areChartStyleObjectsEqual(chartStyleJsonOfChartStyleBeingViewed.value, chartStyleJsonBeingViewed.value);
  });

  if (!hasInitialized) {
    watch(doesChartBeingViewedHaveUnsavedChanges, setPageOnBeforeUnloadCallback);
    watch(chartBeingViewed, setPageOnBeforeUnloadCallback);

    hasInitialized = true;
  }

  return {
    doesChartBeingViewedHaveUnsavedChanges,
    doesChartStyleBeingViewedHaveUnsavedChanges
  };
}
